define('views/blocks/CheckoutAddressView',['underscore', 'backbone', 'jquery', 'app', 'SubView', 'string', 'site_vars', 'hooks',
    'mapboxGL',
    'SelectView',
    'InputView',
    'InputPhoneView',
    'views/blocks/DateTimeSelectorView',
    'views/blocks/AddressIconAliasSelectorView',
    'AddressAutocompleteView',
    'template!blocks/checkout/order-options',
    'template!blocks/checkout/delivery-options',
    'template!blocks/checkout/delivery-informations',
    'template!blocks/checkout/click-and-collect',
    'template!blocks/checkout/click-and-delivery',

], function (_, Backbone, $, app, SubView, S, site_vars, hooks,
            mapboxGL,
            SelectView,
            InputView,
            InputPhoneView,
            DateTimeSelectorView,
            AddressIconAliasSelectorView,
            AddressAutocompleteView,
            orderOptionsTemplate,
            deliveryOptionsTemplate,
            deliveryInformationsTemplate,
            checkoutVAETemplate,
            checkoutVADTemplate
)
{

    var translationContext = 'Checkout',
        checkoutModel;
    // mapboxGL classes
    var Map,Marker,Point,LngLat;
    function InitMapboxGL(callback){
        // init Google Classes refs
        mapboxGL.init(function(mapboxGLJS){
            Map = mapboxGLJS.Map;
            Point = mapboxGLJS.Point;
            Marker = mapboxGLJS.Marker;
            LngLat = mapboxGLJS.LngLat;
            callback();
        });

    }

    var CheckoutAddressView = Backbone.View.extend(SubView).extend({
        events: {
            'click .change-delivery':'requireDeliveryOptions',
            'click .change-datetime':'requireDatetimeSelector',
            'click button.change-mode':'switchMode',
            'click .delivery-address-alias': 'clickDeliveryAddressAlias',
            'change .input-phone input':'onChangePhone',
            'blur .input-phone input':'onChangePhone',
            'change [name="order-taxidentificationnumber"]':'onChangeTIN',
            'change [name="useasphonecustomer"]':'onChangeUseAsPhoneCustomer',
            'change [name="address-data"]':'onChangeAddressData',
            'click .switch-delivery': 'clickSwitchDeleveryType'
        },
        initialize: function (options)
        {
            var view = this;
            checkoutModel = options.checkout;
            view.subviews = [];
            view.render();
            view.listenTo(app.getCart(),'deliveryUpdate',view.onDeliveryUpdate);
            view.listenTo(checkoutModel,'focusAddressData',view.focusAddressData);
            view.listenTo(app,'changeAddressAlias',view.onDeliveryUpdate);
        },

        render: function ()
        {
            var view = this;
            view.updateAddressDetails();
            view.attachViews(SelectView.initializeSelectsOfView(view));
            view.attachViews(InputPhoneView.initializeInputsOfView(view));
            view.attachViews(InputView.initializeInputsOfView(view));
            hooks.execHook('hookCheckoutCagnottageDataView', {
                cart: checkoutModel.getCart(),
                view: view,
                selector: '.checkout-cagnottage-block.cagnottage-step-payment',
                context: 'stepPayment',
            });
        },

        renderStep:function(){
            var view = this,
                rawHtml = deliveryOptionsTemplate(checkoutModel);

            view.undelegateEvents();
            view.$el.html(rawHtml);

            view.render();
            view.delegateEvents();
        },

        onChangePhone:function(e){
            var phoneE164 = $(e.currentTarget).data('E164');
            checkoutModel.set('phone',phoneE164);
        },

        onChangeTIN:function(e){
            var tax_identification_number = e.currentTarget.value;
            checkoutModel.set('tax_identification_number',tax_identification_number);
        },

        onChangeUseAsPhoneCustomer:function(e){
            var useAsPhoneCustomer = e.currentTarget.checked;
            checkoutModel.set('useasphonecustomer',useAsPhoneCustomer);
        },

        onChangeAddressData:function(e){
            checkoutModel.set('addressData',e.currentTarget.value);
        },

        focusAddressData:function(){
            this.$('[name="address-data"]').focus();
        },

        updateAddressDetails:function() {
            if (!app.getCart().isVAE()) {
                var view = this, deliveryAddress;
                deliveryAddress = view.renderAddressDetails();
                view.stopListening(deliveryAddress,'sync',view.renderAddressDetails);
                view.listenTo(deliveryAddress,'sync',view.renderAddressDetails);
            }
        },

        clickDeliveryAddressAlias:function(){
            var view = this,
                wrapper = view.$('.address-icon-alias-selector__wrapper');
            wrapper.append('<div class="address-icon-alias-selector__x"></div>');
            view.appendView(AddressIconAliasSelectorView,'.address-icon-alias-selector__x',{type:'cart'});
        },

        renderAddressDetails:function(){
                var view = this, place, data,
                    selectorPrefix = '.address-',
                    deliveryAddress = app.getCart().getTemporaryAddress(),
                    isAddressEmpty = false,
                    isDataEmpty = true;
                if(deliveryAddress){
                    // cas normal.
                    place = deliveryAddress.getPlace();
                    data = deliveryAddress.getData();
                    //
                    view.$(selectorPrefix+'full-street').text(deliveryAddress.formatFullAddress('fullStreet'));
                    view.$(selectorPrefix+'full-city').text(deliveryAddress.formatFullAddress('fullCity'));
                    view.$(selectorPrefix+'alias').html(deliveryAddress.formatIcon()+deliveryAddress.formatAliasLabel());
                    view.$('[name="address-data"]').val(data);
                    isDataEmpty = data.length==0;
                    if(place && place.isGooglePlace()){
                        var latLng = place.getLatLng();
                        if(latLng){
                            //
                            view._latLng = latLng;
                            InitMapboxGL(function(){
                                view.renderMap();
                            });
                        }else{
                            view.listenToOnce(place,'sync',view.renderAddressDetails);
                            place.fetch();
                        }
                    }
                }else{
                    // en cas d'erreur (pas de selection, pas d'adresse)
                    isAddressEmpty = true;
                }
            //view.$(selectorPrefix+'data-input').toggleClass('empty',isDataEmpty);
            //view.$(selectorPrefix+'data-input').toggleClass('visible',isAddressEmpty);
            view.$(selectorPrefix+'text').toggleClass('empty',isAddressEmpty);
            //
            return deliveryAddress;
        },

        renderShopDetails:function(){
            var view = this,
                selectorPrefix = '.store-',
                cart = app.getCart(),
                store = cart.getStore();
            if(store){
                view.$(selectorPrefix+'name').text(cart.formatStoreName());
                view.$(selectorPrefix+'address').text(cart.getStore().getAddress());
                view.$(selectorPrefix+'city').text(cart.getStore().get('postcode') +' '+ cart.getStore().getCity());
            }
        },

        renderMap:function(){
            //
            //if(!app.isCheckoutMapEnable()) return;
            //
            var view = this,
                latLng = view._latLng,
                $mapEl = view.$('.map-wrapper'),
                mapEl = $mapEl.get(0),
                map = $mapEl.data('map'),
                lngLat,
                marker = $mapEl.data('marker');
            //
            if(mapEl && Map) {
                // on attend que Mapbox soit disponible (Map, LngLat, etc.)
                lngLat = new LngLat(latLng.lng,latLng.lat);
                //
                if(!map){
                    map = new Map({
                        container:mapEl,
                        style: 'mapbox://styles/mapbox/light-v9',
                        center: lngLat,
                        zoom:10
                    });
                }
                if(!marker){
                    var markerEl = document.createElement('div');
                    markerEl.className = 'marker-simple';
                    marker = new Marker({
                        element:markerEl,
                        anchor:'bottom'
                    });
                }
                marker
                    .setLngLat(lngLat)
                    .addTo(map);
                //
                $mapEl.data('map',map);
                $mapEl.data('marker',marker);
                map.setCenter(latLng);
                //
            }
        },

        requireDeliveryOptions:function(){
            app.getCart().requireDeliveryOptions();
        },

        requireDatetimeSelector:function(){
            app.displayModal(new DateTimeSelectorView());
        },

        switchMode:function(){
            var cart = app.getCart();
            this.$('.change-mode').attr('disabled',true);
            this.$('.change-mode .circle-loader').addClass('playing');
            cart.isVAE() ? cart.switchToVAD() : cart.switchToVAE();
        },

        onDeliveryUpdate:function(){
            var view = this,
                cart = app.getCart(),
                isVAE = cart.isVAE();
            if(!_.isUndefined(cart.changed.vae)){
                // si on change de mode, on effectue le rendu de l'étape dans le nouveau mode
                view.renderStep();
            }else{
                // la seule chose qui peut changer quand on change de boutique / adresse, c'est le délai
                view.$('.delivery-time').text(cart.formatDeliveryTimeLabel());
                if(!isVAE){
                    // et les détails de l'adresse, en VAD
                    view.renderAddressDetails()
                }else{
                    // ou du shop en VAE
                    view.renderShopDetails()
                }
            }
        },

        clickSwitchDeleveryType:function(e){
           var cart = app.getCart();
           if(cart.isVAE()){
               cart.switchToVAD();
            }else{
               cart.switchToVAE();
            }
        },

    });



    return CheckoutAddressView;


})
;
